/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, Output } from '@angular/core';
import { AmiDetailsTemplate } from 'src/app/@amiga-pyme/components/ami-details/ami-detail.template';

@Component({
  selector: 'pg-provider-details',
  template: `
    <p-fieldset [legend]="legend" [toggleable]="true">
      <ami-details
        [settings]="settings"
        (action)="onReciveAction($event)"
      ></ami-details>
    </p-fieldset>
    <!-- 
    <pg-provider-select
      *ngIf="select.canBeDisplay"
      (selectedRowsEvent)="onSelected($event); prueba2 = $event"
    ></pg-provider-select>
     -->
    <pg-provider-select
      *ngIf="select.canBeDisplay"
      (selectedRowsEvent)="onSelected($event)"
    ></pg-provider-select>
  `
})
export class ProviderDetailsComponent extends AmiDetailsTemplate {
  @Input() legend = 'Proveedor';
  @Input() data;
  // @Input() enable;
  // prueba2;
  // ngOnChanges(changes: any) {
  //   this.settings = {
  //     head: {
  //       title: '',
  //       subtitle: ''
  //     },
  //     body: {
  //       rows: [
  //         { header: 'RUC', field: 'ruc' },
  //         { header: 'Nombre', field: 'name' },
  //         { header: 'Dirección', field: 'address' }
  //       ]
  //     }
  //   };
  //   if (this.enable) {
  //     this.clear2(this.prueba2);
  //   } else {
  //     this.clear(this.prueba2);
  //   }
  // }
  ngOnInit() {
    this.settings = {
      head: {
        title: '',
        subtitle: ''
      },
      body: {
        rows: [
          // { header: 'RUC', field: 'ruc' },
          { header: 'Nombre', field: 'name' }
          // { header: 'Dirección', field: 'address' }
        ]
      }
    };
    this.addActionSelect();
    this.onSelected(this.data);
  }
}

export class ProviderSelected {
  value: any;
  legend: any;
  constructor(legend = 'Proveedor') {
    this.value = null;
    this.legend = legend;
  }
  onSelect(row) {
    if (row) {
      this.value = row;
    }
  }

  onReset() {
    this.value = null;
  }

  getId() {
    return this.value?.id;
  }

  setId(row) {
    if (row) {
      this.value = row;
    }
  }
}
